import Avatar from "@mui/material/Avatar";
import SectionCard from "../SectionCard";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import { useDashboard } from "../../context/HDBDashboardContext";
import ReviewOverlay from "../RatingOverLay";
import { useState } from "react";

const YetToReview = ({ data, programId }) => {
  const navigate = useNavigate();
  if (!data?.values?.length) return null;
  const { updateFilters } = useDashboard();

  // State for review overlay
  const [showReviewOverlay, setShowReviewOverlay] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const showAllReviews = () => {
    updateFilters(data.filters);
  };

  const handleRowClick = (user) => {
    setSelectedUser(user);
    setShowReviewOverlay(true);
  };

  // When review is saved, close overlay and clear selected user
  const handleSaveReview = () => {
    setShowReviewOverlay(false);
    setSelectedUser(null);
  };

  // Helper to get initial ratings object
  const getInitialRatings = (user) => {
    if (Array.isArray(user?.ratings)) {
      return user.ratings.reduce((acc, r) => {
        acc[r.ratingKey] = { rating: r.rating, id: r.id };
        return acc;
      }, {});
    }
    return {};
  };

  return (
    <>
      <SectionCard
        title={data.displayName || "Yet to review"}
        totalLabel={`${data.count ?? data.values.length}`}
        label="Total"
        onClick={showAllReviews}
        actionItem="view all"
      >
        {data?.values?.map((user, index) => {
          const avatar = user.userProfileUrl || `/avatars/default.png`;
          const name = user.fullName || "Unknown";
          const hdbs = user.noOfHdbs ?? 0;

          return (
            <div
              key={index}
              className={styles.reviewItem}
              onClick={() => handleRowClick(user)}
            >
              <Avatar src={avatar} alt={name} className={styles.avatar} />
              <span className={styles.name}>{name}</span>
              <div className={styles.hdbsContainer}>
                <span>
                  <span className={styles.hdbs}>
                    {String(hdbs).padStart(2, "0")}
                  </span>
                  <span className={styles.hdbsText}> HDBs</span>
                </span>
              </div>
            </div>
          );
        })}
      </SectionCard>
      {showReviewOverlay && selectedUser && (
        <ReviewOverlay
          open={true}
          onClose={() => {
            setShowReviewOverlay(false);
            setSelectedUser(null);
          }}
          onSave={handleSaveReview}
          seekerId={selectedUser?.programRegistrationId}
          programId={programId}
          initialRatings={getInitialRatings(selectedUser)}
          initialComments={selectedUser?.rmComments || ""}
          seekersData={selectedUser}
          disablePreferences={true}
        />
      )}
    </>
  );
};

export default YetToReview;
